import { useParams } from "react-router-dom"
import { InvoiceForm } from "./Form/InvoiceForm"
import { InvoiceProps } from "../../interfaces/invoices_types"
import { useState } from "react"
import { useEffect } from "react"
import { getInvoiceById } from "../../api/invoices"
import { CreateInvoiceForm } from "../Projects/Form/InvoiceForm/InvoiceFormContainer"

// Create Invoice doesn't actuly work through here, it should be done through the project update page
export function CreateInvoice() {
    return (
        <CreateInvoiceForm />
    )
}

export function EditInvoice() {
    const { id } = useParams<string>()
    const [invoice, setInvoice] = useState<InvoiceProps>()

    useEffect(() => {
        if (!id) return

        const getInvoice = async () => {
            const response = await getInvoiceById(id)
            setInvoice({...response.data, invoice_id: id})
        }

        getInvoice()
    }, [id])

    return (
        <div>
            {invoice && <InvoiceForm method="PUT" current_invoice_data={invoice}/>}
        </div>
    )
}